import apiPO from '@/api/supplier/po';
import apiOption from '@/api/supplier/option';

const defaultState = () => ({
	listPO: [],
	detailPO: '',
	poPagination: '',
	OptionPO: [],
	optionWarehouse: [],
	supplierProducts: [],
	supplierProductsPagination: {},
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
	productPO(state){
		if (state.detailPO.po_detail) {
			return state.detailPO.po_detail.map((el) => {
				return {
					product_id: el.po_detail_product_id,
					price: el.po_detail_product_price,
					quantity: el.po_detail_quantity_approved
				}
			})
		}
	},
	productPDO(state){
		if (state.detailPO) {
			return state.detailPO.po_detail.map((el) => {
				return {
					product_id: el.po_detail_product_id,
					quantity: el.deliver.replace(/\D/g, ""),
				}
			})
		}
	}
};

const mutations = {
	setPO(state, data) {
		state.listPO = data.data
		state.poPagination = data.pagination;
	},
	setDetailPO(state, data) {
		state.detailPO = data
	},
	setOptionPO(state, data){
		state.OptionPO = data
	},
	listOptionWarehouse(state, data) {
		state.optionWarehouse = data
	},
	setSupplierProducts(state, data) {
		if (data == 'error') {
			state.supplierProducts = data.data
		} else {
			state.supplierProducts = data.data.map((el) => {
				el.selected = false
				el.quantity = 1
				return el
			});
		}
		state.supplierProductsPagination = data.pagination
	},
	saveResponse(state, data) {
		state.response = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataPO(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getPO({ commit }, params) {
		return new Promise((resolve) => {
			apiPO.getPO(params).then(({ data: { data } }) => {
				commit('setPO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setPO', { data: [], pagination: {} });
			});
		});
	},
	getPOforPDO({ commit }, params) {
		apiPO.POforPDO(params).then(({ data: { data } }) => {
			commit('setPO', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setPO', { data: [], pagination: {} });
		});
	},
	getDetailPO({ commit, dispatch }, params) {
		apiPO.detailPO(params).then(({ data: { data } }) => {
			commit('setDetailPO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailPO', { data: [] });
		});
	},
	getSupplierProducts({ commit }, params){
		apiPO.getSupplierProducts(params).then(({ data: { data } }) => {
			commit('setSupplierProducts', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setSupplierProducts', { data: [], pagination: {} });
		});
	},
	async exportPO({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiPO.exportPO(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data pemesanan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async getOptionPOforApprove({ commit }){
		await apiOption.poforApprove().then( ({ data: { data } }) => {
			commit('setOptionPO', data.results);
		}).catch(() => {
			commit('setOptionPO', []);
		});
	},
	getOptionWarehouse({ commit }, value) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouse(value).then(({ data: { data } }) => {
				commit('listOptionWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('listOptionWarehouse', []);
			});
		});
	},
	async approvePO({ commit, dispatch }, params) {
		await apiPO.approvePO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menyetujui Purchase Order'
			}, { root: true });
		});
	},
	async rejectPO({ commit, dispatch }, params) {
		await apiPO.rejectPO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membatalkan Purchase Order'
			}, { root: true });
		});
	},
	async deletePO({ commit, dispatch }, params) {
		await apiPO.deletePO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus Purchase Order'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};